import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from "@/components/ui/context-menu"; // Assuming Dropdown items were placeholders

export const FileContextMenu = ({
  children,
  onRename,
  onDelete,
  onCreateNewFile,
  onCopyFile,
  onImproveTests,
  onRunTests,
  onFixTests,
  canRunTests,
  canFixTests,
  canCopyFile,
}: {
  children: React.ReactNode;
  onRename: () => void;
  onDelete: () => void;
  onCreateNewFile: () => void;
  onCopyFile?: () => void;
  onImproveTests: () => void;
  onRunTests: () => void;
  onFixTests: () => void;
  canRunTests?: boolean;
  canFixTests?: boolean;
  canCopyFile?: boolean;
}) => {
  return (
    <ContextMenu>
      <ContextMenuTrigger>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem onSelect={onRename}>Rename</ContextMenuItem>
        <ContextMenuItem onSelect={onDelete}>Delete</ContextMenuItem>
        <ContextMenuItem onSelect={onCreateNewFile}>New File</ContextMenuItem>
        {canCopyFile && (
          <ContextMenuItem onSelect={() => onCopyFile?.()} disabled={!onCopyFile}>
            Copy File
          </ContextMenuItem>
        )}
        <ContextMenuSeparator />
        <ContextMenuItem onSelect={onRunTests} disabled={!canRunTests}>Run Tests</ContextMenuItem>
        <ContextMenuItem onSelect={onFixTests} disabled={!canFixTests}>Fix Failing Tests</ContextMenuItem>
        <ContextMenuItem onSelect={onImproveTests}>Improve Tests</ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
};